import { useEffect } from "react";
import { mediaUrl } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path = "/", image, jsonLd }) {
  const { settings } = useSite();
  const siteUrl = (settings?.site_url || "").replace(/\/$/, "");
  const fullTitle = title ? `${title} | Douzième Homme — Le Jeu` : settings?.seo_title;
  const desc = description || settings?.seo_description;
  const canonical = `${siteUrl}${path}`;
  const ogImage = mediaUrl(image || settings?.og_image);

  useEffect(() => {
    if (fullTitle) document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:locale", "fr_FR");
    setMeta("name", "twitter:card", "summary_large_image");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
    let ld = document.getElementById("jsonld-page");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "jsonld-page";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [fullTitle, desc, canonical, ogImage, jsonLd]);

  return null;
}
